import React from 'react';
import OwlCarousel from 'react-owl-carousel';

import 'owl.carousel/dist/assets/owl.carousel.css'; // Import Owl Carousel styles
import 'owl.carousel/dist/assets/owl.theme.default.css'; // Import Owl Carousel default theme styles

const ImageCarousel = ({ images }) => {

    const options = {
        loop: true,
        // autoHeight: false,
        margin: 10,
        autoplay: true,
        smartSpeed: 3000,
        autoplayTimeout: 6000,
        items: 1,
        nav: true,
        navText: [
          '<span class="icon-keyboard_backspace"></span>',
          '<span class="icon-keyboard_backspace"></span>',
        ],
        touchDrag: false,
        mouseDrag: false,
        pullDrag: false,
      };

  return (
    <OwlCarousel className="owl-theme" {...options}>
      {images.map((image, index) => (
        <div key={index} className="item">
          <img src={image} alt={`Image ${index}`}/>
        </div>
      ))}
    </OwlCarousel>
  );
};

export default ImageCarousel;
